import { atom, PrimitiveAtom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { TDiscoverData } from 'shared/models';

type DiscoverStore = { [key: string]: Promise<TDiscoverData> | undefined };

const $DiscoverDataStore: PrimitiveAtom<DiscoverStore> = atom<DiscoverStore>({});

export const $DiscoverData = safeAtomFamily((keyword: string) => {
  const a = atom(
    (get) => {
      const data = get($DiscoverDataStore)[keyword];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, args: any) => {
      const old = get($DiscoverDataStore);
      set($DiscoverDataStore, { ...old, [keyword]: args });
    },
  );

  a.debugLabel = `$DiscoverData+${encodeURIComponent(keyword)}`;

  return a;
});
